import { publicEnv } from '@/shared/config/publicEnv'
import { compact } from 'lodash'
import {
    initializeObservability,
    OBSERVABILITY_FALLBACKS,
    type ObservabilityClientConfig
} from '@hello-aria/observability/client'

/**
 * The cross-origin APIs the browser sends `traceparent` to.
 *
 * Makalu calls its API on its own host (`api.helloaria.eu` and its staging and
 * sandbox siblings), so every request is cross-origin and none of them carries
 * the header by default. That API must allow `traceparent` in its CORS policy,
 * or the browser drops the whole request.
 */
const tracedApiUrls = compact([publicEnv.baseApiUrl])

export const observabilityConfig: ObservabilityClientConfig = {
    collectorUrl: publicEnv.faroUrl ?? '',
    app: {
        name: 'Makalu',
        version: publicEnv.appVersion ?? OBSERVABILITY_FALLBACKS.version,
        environment: publicEnv.environment ?? OBSERVABILITY_FALLBACKS.environment,
        namespace: publicEnv.faroAppNamespace ?? OBSERVABILITY_FALLBACKS.namespace
    },
    tracedApiUrls
}

/**
 * Starts Faro with this app's config.
 *
 * ARCH-13: `instrumentation-client.ts` calls this rather than the package, so
 * the collector config has one reader. The package skips a start with no
 * collector URL, which is how a local run and a preview behave.
 */
export const startObservability = () => initializeObservability(observabilityConfig)
